// extracted by mini-css-extract-plugin
export default {"PopularQueries":"PopularQueries_PopularQueries__hs1Xa","PopularQueries__title":"PopularQueries_PopularQueries__title__KT155"};